import React, { useState } from 'react';
import { Container, Col, Row, Form, Modal, Image } from 'react-bootstrap';
import '../../Assets/css/productlist.css';
import Button from '@mui/material/Button';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import AppsIcon from '@mui/icons-material/Apps';
import ListIcon from '@mui/icons-material/List';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Pagination from '@mui/material/Pagination';
import Slider from 'react-slick';
import eye from '../../Assets/images/eye.svg';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import FavoriteIcon from '@mui/icons-material/Favorite';
import cart from '../../Assets/images/cart.png';
import heart from '../../Assets/images/heart.svg';
import inquir from '../../Assets/images/inquir.svg';
import { Drawer, TextField, makeStyles, Divider, CircularProgress } from '@material-ui/core';
import { NavLink, useHistory } from 'react-router-dom';
import { useEffect } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import { base_url, client_name, currency, currencycode, isLogin, postHeader, user } from '../../Helpers/request';
import CloseIcon from '@material-ui/icons/Close';
import { Helmet } from 'react-helmet';
import { Skeleton } from '@mui/material';
import { isMobileOnly } from 'react-device-detect';
import { ProductEnquiry } from '../../Components/Modals';
import { useDispatch, useSelector } from 'react-redux';
import { cartlengthvalue } from '../../Reducer/cartReducer';
import { whishlistlength } from '../../Reducer/wishlistReducer';
import { store } from '../../Store/store';
import { sessionId } from '../../Reducer/homeReducer';
import ShopStyle from '../../Assets/css/RingDiamondShop.module.css'
import vline from '../../Assets/newImg/vline.png'
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
function handleClick(event) {
  event.preventDefault();
  console.info('You clicked a breadcrumb.');
}
const highlightedStyle = {
  // backgroundColor: "yellow", // or any other highlight color
  fontWeight: "bold",
};
const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: theme.typography.fontWeightRegular,
  },
}));
const FirstContentDefault = () => {
  return (
    <>
      <p>
        {" "}
        Swales Diamond is proud to offer an exquisite collection of {" "}
        <span style={highlightedStyle}>
        wedding rings in Birmingham, 
        </span>{" "}
        designed with exceptional craftsmanship and elegance. Each piece is carefully crafted using high-quality materials to ensure durability and beauty. Our wedding rings are available in various styles, from classic to modern, with options encrusted with diamonds or simple, refined bands, ensuring every couple finds their perfect match. ...
      </p>
      {/* <p>Our range of engagement rings is diverse and budget-friendly, catering to different styles and budget preferences. From classic solitaire rings to custom pieces, from white gold to platinum, we have something for everyone. We understand that buying an engagement ring is a once-in-a-lifetime opportunity, and you want to make the most of it. That is why we only deal in quality rings that will stand the test of time. Also, we don't want you to settle for anything but the best, which is why we have such a diverse price range for our <span style={highlightedStyle}>engagement
      rings in Birmingham.</span> You can explore our readymade collection of rings or speak with our experts for a custom quote. Based on your preferences, we will be happy to design your dream ring for you in our Birmingham showroom. 
      </p> */}
    </>
  );
};
const FirstContentFull = (
  <>
    <p>
    Swales Diamond is proud to offer an exquisite collection of {" "}
      <span style={highlightedStyle}> wedding rings in Birmingham,</span>{" "}
      designed with exceptional craftsmanship and elegance. Each piece is carefully crafted using high-quality materials to ensure durability and beauty. Our wedding rings are available in various styles, from classic to modern, with options encrusted with diamonds or simple, refined bands, ensuring every couple finds their perfect match.{" "}
    </p>
    <p>
    At Swales Diamonds, we believe choosing your  <span style={highlightedStyle}> wedding rings in Birmingham </span>
    should be a stress-free and joyful experience. That’s why our knowledgeable team is on hand to guide you through every step, from the initial consultation to the final handover. We take pride in offering a seamless and enjoyable shopping experience while ensuring your rings meet the highest standards of quality and design. Visit us today to explore our collection, and let us help you find the rings that reflect your love and commitment.{" "}
    </p>
  </>
);
const faqData = [
  {
    id: "panel2",
    title: "Why are wedding rings on left hand?",
    content:
      "Wedding rings are traditionally worn on the left hand due to an ancient belief that the fourth finger on the left hand has a vein directly connected to the heart, symbolising love and commitment."
  },
  {
    id: "panel3",
    title: "Is Birmingham Jewellery Quarter cheaper?",
    content:  "Birmingham’s Jewellery Quarter is known for offering high-quality jewellery at competitive prices. With skilled artisans and manufacturers, it’s a popular destination for affordable yet exquisite wedding rings and other jewellery."
  },

];

const LongText = ({ getHighlightedDefaultText, fullText }) => {
  const [isExpandedd, setIsExpandedd] = useState(false);
  const toggleText = () => {
    setIsExpandedd(!isExpandedd);
  };

  return (
    <div>
      <p>
        {isExpandedd ? fullText : getHighlightedDefaultText()}
        <span onClick={toggleText}>
          {" "}
          <strong style={{cursor:"pointer"}}>{isExpandedd ? "Read Less" : "Read More"}</strong>
        </span>
      </p>
      {/* <button onClick={toggleText}>
        {isExpanded ? 'Show Less' : 'Show More'}
      </button> */}
    </div>
  );
};
const Productlist = (props) => {

  const history = useHistory();
  const session_Id = useSelector((state) => state.persistedReducer.home.session_id);
  var settings = {
    dots: false,
    infinite: true,
    speed: 500,
    accessibility: true,
    arrows: true,
    slidesToShow: 1,
    slidesToScroll: 1,
  };
  const [view, setView] = useState(1);
  const [inquiry, setInquiry] = useState(false);
  const [quickView, setQuickView] = useState(false);
  const [categoryrun, setCategoryrun] = useState(false);
  const [listdata, setListdata] = useState([]);
  const [bannerdata, setBannerdata] = useState('');
  const [catediscription, setCatediscription] = useState('');
  const [metacatediscription, setMetacatediscription] = useState('');
  const [catetitle, setCatetitle] = useState('');
  const [catekeyword, setCatekeyword] = useState('');
  const [productCount, setProductCount] = useState(0);
  const [pageCount, setPageCount] = useState(0);
  const [page, setPage] = useState(1);
  const [sortby, setSortby] = useState('');
  const [filterdata, setFilterdata] = useState([]);
  const [demofilterlist, setDemofilterlist] = useState([]);
  const [addedfilter, setAddedfilter] = useState(JSON.parse(sessionStorage.getItem('bw-listfilter')) ? JSON.parse(sessionStorage.getItem('bw-listfilter')) : []);
  const handleCloseInquiry = () => setInquiry(false);
  const handleShowInquiry = () => setInquiry(true);
  const handleCloseQuickView = () => setQuickView(false);
  const [quickdata, setQuickdata] = React.useState([]);
  const [expanded, setExpanded] = React.useState([]);
  const [paramid, setParamid] = useState(props.match.params.listcategory ? props.match.params.listcategory : props.match.params.search_text);
  const [first_name, setFirst_name] = useState('');
  const [last_name, setLast_name] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [comment, setComment] = useState('');
  const [productid, setProductid] = useState('');
  const [loader, setLoader] = useState(true);
  const [showFilter, setShowFilter] = useState(true);
  const [filtercount, setFiltercount] = useState(0);
  const [search_param, setSearch_param] = useState(props.match.params.search_text ? props.location.pathname?.replaceAll("/search/","") : "");
  const [proIndex, setProIndex] = useState('');
  
  const dispatch = useDispatch();
  const location = useLocation();

  // const handleChangeFaq = (panel) => (event, isExpanded) => {
  //   console.log('panel',panel,isExpanded,expanded);
    
  //   setExpanded(isExpanded ? panel : false);
  // };
  const handleChangeFaq = (panel) => (event, isExpanded) => {
    setExpanded(prevExpanded => 
        isExpanded ? [...prevExpanded, panel] : prevExpanded.filter(p => p !== panel)
    );
};
  const submitForm = () => {
    var data = {
      product_id: productid,
      first_name,
      last_name,
      email,
      mobile: phone,
      message: comment,
    };
    axios
      .post(base_url + '/product/enquiry', data, {
        headers: postHeader,
      })
      .then((response) => {
        if (response.data.status == 1) {
          setFirst_name('');
          setLast_name('');
          setEmail('');
          setComment('');
          setPhone('');
          toast.success(response.data.message, { autoClose: 3000 });
        } else {
          toast.error(response.data.message, { autoClose: 3000 });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const handleChange = (panel) => (event, newExpanded) => {
    setShowFilter(true);
    if (expanded.includes(panel)) {
      var data = expanded?.filter(function (person) {
        return person !== panel;
      });
      setExpanded(data);
    } else {
      setExpanded([...expanded, newExpanded ? false : panel]);
    }
  };
  useEffect(() => {
    filterApi();
  }, [props.match.params.listcategory, props.match.params.search_text, props.location.pathname]);
  useEffect(() => {
    if (categoryrun) {
      productlist();
      setParamid(props.match.params.listcategory ? props.match.params.listcategory : search_param);
    }
  }, [page]);

  useEffect(() => {
    if (categoryrun) {
      productlist();
      setPage(1);
      setParamid(props.match.params.listcategory ? props.match.params.listcategory : search_param);
      var count = 0;
      addedfilter?.map((val) => {
        if (val?.name.length) {
          count++;
        }
      });
      count > 0 ? setFiltercount(1) : setFiltercount(0);
    }
  }, [addedfilter, props.match.params.listcategory, props.match.params.search_text, sortby]);

  const getFirstPart = (val) => {
    if (val !== undefined) {
      return val.split('=')[0];
    }
  };
  const filterApi = () => {
    setCategoryrun(true);
    const data = {
      currency_code: currencycode,
      category: props.match.params.listcategory ? props.match.params.listcategory : '',
      search_text: props.match.params.search_text ? search_param : '',
    };
    axios
      .post(base_url + '/product/productfilter', data, {
        headers: postHeader,
      })
      .then((res) => {
        console.log(props?.match?.params?.subcategory, props?.match?.params?.subcategory?.length);
        if (res.data.status == 1) {
          setFilterdata(res.data.data);
          setSortby(res.data.data?.sort_by[0]?.value);
          if (data.category == sessionStorage.getItem('bw-list-category') && props?.match?.params?.subcategory == undefined && props?.match?.params?.subcategory.length == undefined) {
            setAddedfilter(JSON.parse(sessionStorage.getItem('bw-listfilter')));
          } else {
            var list = [];
            res.data.data?.normal_filters?.map((val) => {
              if (val.title == 'Material' && getFirstPart(props?.match?.params?.subcategory) === 'material') {
                list.push({ title: val.title, filter: [props?.match?.params?.subcategory?.replaceAll('material=', '')], name: [props?.match?.params?.subcategory?.replaceAll('material=', '')?.replaceAll('-', ' ')] });
              } else if (val.title == 'Gender' && getFirstPart(props?.match?.params?.subcategory) === 'gender') {
                list.push({ title: val.title, filter: [props?.match?.params?.subcategory?.replaceAll('gender=', '')], name: [props?.match?.params?.subcategory?.replaceAll('gender=', '')?.replaceAll('-', ' ')] });
              } else if (val.title == 'Style' && getFirstPart(props?.match?.params?.subcategory) === 'style') {
                list.push({ title: val.title, filter: [props?.match?.params?.subcategory?.replaceAll('style=', '')], name: [props?.match?.params?.subcategory?.replaceAll('style=', '')?.replaceAll('-', ' ')] });
              } else if (val.title == 'Brand' && getFirstPart(props?.match?.params?.subcategory) === 'brand') {
                list.push({ title: val.title, filter: [props?.match?.params?.subcategory?.replaceAll('brand=', '')], name: [props?.match?.params?.subcategory?.replaceAll('brand=', '')?.replaceAll('-', ' ')] });
              } else {
                list.push({ title: val.title, filter: [], name: [] });
              }
            });
            setAddedfilter(list);
            setDemofilterlist(list);
            sessionStorage.setItem('bw-list-category', data.category);
            sessionStorage.setItem('bw-listfilter', JSON.stringify(list));
          }
        } else {
          toast.error(res.message, { autoClose: 3000 });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const productlist = () => {
    setLoader(true);
    const data = {
      currency_code: currencycode,
      sort_by: sortby,
      setwithmin: '0.51',
      setwithmax: '0.60',
      category: props.match.params.listcategory ? props.match.params.listcategory : '',
      search_text: props.match.params.search_text ? search_param : '',
      filterdata: addedfilter,
      limit: 18,
      offset: (page - 1) * 18,
      user_id: user.user_id ? user.user_id : '',
      session_id: session_Id,
    };
    axios
      .post(base_url + '/product/productlist', data, {
        headers: postHeader,
      })
      .then((res) => {
        if (res.data.status == 1) {
          setLoader(false);
          setListdata(res.data.data?.result);
          setBannerdata(res.data.data?.image);
          setCatediscription(res.data.data?.description);
          setMetacatediscription(res.data.data?.meta_desp);
          setCatekeyword(res.data.data?.meta_keywords);
          setCatetitle(res.data.data?.meta_title);
          setProductCount(res.data.data?.count);
          var count = (res.data.data?.count / 18).toFixed();
          if (count * 18 >= res.data.data?.count) {
            setPageCount(count);
          } else {
            setPageCount(Number(count) + 1);
          }
          if (res.data.data?.count == 0) {
            setShowFilter(false);
          } else {
            setShowFilter(true);
          }
        } else if (res.data.status == 2) {
          localStorage.removeItem('bw-user');
          dispatch(whishlistlength(0));
          dispatch(cartlengthvalue(0));
          dispatch(sessionId(''));
          history.push('/');
          window.location.reload(true);
        } else {
          setListdata([]);
          setProductCount(0);
          setPageCount(0);
          toast.error(res.message, { autoClose: 3000 });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const handlecheckChange = (e, title, value, name) => {
    var changedata = [...addedfilter];
    addedfilter?.map((val) => {
      var filterdata = [...val.filter];
      var fname = [...val.name];
      if (val.title == title) {
        if (val.filter?.includes(value)) {
          filterdata = val.filter?.filter((data) => data !== value);
          fname = val.name?.filter((data) => data !== name);
        } else {
          filterdata.push(value);
          fname.push(name);
        }
        changedata = changedata.map((obj) => (obj.title == title ? Object.assign(obj, { filter: filterdata, name: fname }) : obj));
        setAddedfilter(changedata);
        sessionStorage.setItem('bw-listfilter', JSON.stringify(changedata));
      }
    });
  };
  const checkboxcheck = (title, value, i) => {
    var data = false;
    if (addedfilter[i]?.title == title) {
      if (addedfilter[i]?.filter?.includes(`${value}`)) {
        data = true;
      }
    }
    return data;
  };

  const addtowishlist = (val, wishindex) => {
    const data = {
      currency_code: currencycode,
      user_id: user.user_id ? user.user_id : '',
      session_id: session_Id,
      product_id: val.product_id,
      type: 'JEWELRY',
      token: isLogin ? user.token : '',
    };
    axios
      .post(base_url + '/order/add_to_wishlist', data, {
        headers: postHeader,
      })
      .then((res) => {
        if (res.data.status == 1) {
          dispatch(whishlistlength(res.data.data.count));
          const productlist = listdata.map((obj, index) => (index == wishindex ? Object.assign(obj, { is_wishlist: res.data.data.wishlist_id }) : obj));
          setListdata(productlist);
        } else if (res.data.status == 2) {
          localStorage.removeItem('bw-user');
          dispatch(whishlistlength(0));
          dispatch(cartlengthvalue(0));
          dispatch(sessionId(''));
          history.push('/');
          window.location.reload(true);
        } else {
          toast.error(res.data.message, { autoClose: 3000 });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const addtocart = (product_id) => {
    const data = {
      currency_code: currencycode,
      user_id: user.user_id ? user.user_id : '',
      session_id: session_Id,
      product_id,
      quantity: '1',
      ring_size: '',
      engraving_text: '',
      engraving_font: '',
      token: isLogin ? user.token : '',
      type: 'jewelry',
    };
    axios
      .post(base_url + '/order/add_to_cart', data, {
        headers: postHeader,
      })
      .then((res) => {
        if (res.data.status == 1) {
          dispatch(cartlengthvalue(res.data.data.total_count));
          history.push('/cart');
          toast.success(res.data.message, { autoClose: 3000 });
        } else if (res.data.status == 2) {
          localStorage.removeItem('bw-user');
          dispatch(whishlistlength(0));
          dispatch(cartlengthvalue(0));
          dispatch(sessionId(''));
          history.push('/');
          window.location.reload(true);
        } else {
          toast.error(res.data.message, { autoClose: 3000 });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const handlePageChange = (e, value) => {
    setPage(value);
    window.scrollTo(0, 0);
  };
  const [left, setLeft] = useState(false);

  const quickopen = (data) => {
    setQuickdata(data);
    setQuickView(true);
  };
  const prev = () => {
    if (Number(page) > 1) {
      setPage(Number(page) - 1);
      window.scrollTo(0, 0);
    }
  };
  const next = () => {
    if (Number(page) < pageCount) {
      setPage(Number(page) + 1);
      window.scrollTo(0, 0);
    }
  };
  const metaDetails = useSelector((state) => state.persistedReducer.meta.meta);
  
  console.log("location", location.pathname);
 
  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>
          {catetitle}
        </title>
        <meta name="description" content={catediscription}></meta>
        <meta name="keywords" content={catekeyword}></meta>
        <link rel="canonical" href={window.location.href}></link>
        {/* <link rel="canonical" href={`https://hemmingjewelers.com/jewellery/${props.match.params.listcategory}`} /> */}
      </Helmet>
      {location.pathname === "/jewellery/wedding-rings" && <div className="sl_eng_pera_top_box">
        <Container>
          <Row>
            <Col>
              <div className="sl_pera_box">
                <h1>Wedding Rings Birmingham</h1>
                <LongText
                  getHighlightedDefaultText={FirstContentDefault}
                  fullText={FirstContentFull}
                />
              </div>
            </Col>
          </Row>
        </Container>
      </div>}
      {/* <div className={ShopStyle.BannerTop}>
        <Container>
          <h2 className={ShopStyle.Title + ' pb-0'}>{ paramid === 'fine-jewelry' ? 'Fine Jewellery' : paramid?.charAt(0).toUpperCase() + paramid.slice(1).replace('-', ' ')}</h2>
          {loader ? <Skeleton variant="text" animation="wave" width={'100%'} height={24} /> : <p>{catediscription}</p>}
          <h3 className={ShopStyle.subTitle + ' text-capitalize'}>{loader ? <Skeleton variant="text" animation="wave" className="mb-4" width={'100%'} height={24} /> : catediscription}</h3>
          <ul className={ShopStyle.BreadcrumbS}>
            <li><NavLink to="/">Home</NavLink></li>
            <li>/</li>
            <li>{paramid === 'fine-jewelry' ? 'Fine Jewellery' : paramid?.charAt(0).toUpperCase() + paramid.slice(1).replace('-', ' ')}</li>
          </ul>
        </Container>
      </div> */}

      <div className="rcs_product_list_main">
        {/* <div className="rcs_prodlist_banner mb-3">                   
                    {loader ? <Skeleton variant="text" animation="wave" style={{ transform: 'unset' }} width={'100%'} height={380} /> : isMobileOnly ? '' : <img src={bannerdata} />}
                </div> */}
        <Container fluid className="rcs_customer_container rcs_large_container mt-3">
          <div className={ShopStyle.MainBoxRingDiamondShop + ' ' + ShopStyle.ProductListPage}>
            <div className={ShopStyle.LeftContainer + ' d-none d-xl-block'}>
              <div className="rcs_list_filter rcs_list_filter_tablet tetsttttt px-5">
                <div className="rcs_accordion_sec" sticky="top">
                  <div className="rcs_accordion">
                    {/* filter tags */}
                    <div className="rcs_filter_tags">
                      {!filtercount ? (
                        ''
                      ) : (
                        <div className="rcs_filter_list">
                          <h5>
                            <span>Filtering by:</span>
                            <a
                              href="javascript:void(0)"
                              onClick={() => {
                                setAddedfilter(demofilterlist);
                                sessionStorage.removeItem('bw-listfilter');
                                sessionStorage.removeItem('bw-list-category');
                                filterApi();
                              }}
                              className="clear-all-filters"
                            >
                              CLEAR ALL
                            </a>
                          </h5>
                          <div className="filter_tgs_list">
                            {addedfilter?.map((val) =>
                              val.name?.map((items, index) => (
                                <>
                                  <Button className="gs_filter_btn">
                                    {items}
                                    <CloseIcon onClick={(e) => handlecheckChange(e, val.title, val.filter[index], items)} className="gs_tags_svg" />
                                  </Button>
                                </>
                              )),
                            )}
                          </div>
                        </div>
                      )}
                    </div>

                    {filterdata?.normal_filters?.map((val, index) => (
                      <Accordion expanded={showFilter ? (expanded?.includes('panel' + index) ? false : true) : false} onChange={handleChange('panel' + index)} className="rcs_accordion_item">
                        <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel2a-content" id="panel2a-header">
                          <Typography>{val.title}</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                          <div className="rcs_price_filter px-3">
                            <FormGroup>
                              {val.data?.map((items) => (
                                <>
                                  <FormControlLabel control={<Checkbox checked={checkboxcheck(val.title, items.value, index)} onChange={(e) => handlecheckChange(e, val.title, items.value, items.name)} />} label={items.name} />
                                </>
                              ))}
                            </FormGroup>
                          </div>
                        </AccordionDetails>
                      </Accordion>
                    ))}
                  </div>
                </div>
              </div>

            </div>
            {/* mj left filter bar end */}
            <div className="rcs_mobile_filter_section">
              <Drawer anchor="left" open={left} onClose={() => setLeft(false)}>
                <div role="presentation" onKeyDown={() => setLeft(false)}>
                  <div className="rcs_accordion_sec" sticky="top">
                    <div className="rcs_accordion">
                      {/* filter tags */}
                      <div className="rcs_filter_tags">
                        {!filtercount ? (
                          ''
                        ) : (
                          <div className="rcs_filter_list">
                            <h5>
                              <span>Filtering by:</span>
                              <a
                                href="javascript:void(0)"
                                onClick={() => {
                                  setAddedfilter(demofilterlist);
                                  sessionStorage.removeItem('bw-listfilter');
                                  sessionStorage.removeItem('bw-list-category');
                                  filterApi();
                                }}
                                className="clear-all-filters"
                              >
                                CLEAR ALL
                              </a>
                            </h5>
                            <div className="filter_tgs_list">
                              {addedfilter?.map((val) =>
                                val.name?.map((items, index) => (
                                  <>
                                    <Button className="gs_filter_btn">
                                      {items}
                                      <CloseIcon onClick={(e) => handlecheckChange(e, val.title, val.filter[index], items)} className="gs_tags_svg" />
                                    </Button>
                                  </>
                                )),
                              )}
                            </div>
                          </div>
                        )}
                      </div>
                      {filterdata?.normal_filters?.map((val, index) => (
                        <Accordion expanded={expanded?.includes('panel' + index) ? false : true} onChange={handleChange('panel' + index)} className="rcs_accordion_item">
                          <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel2a-content" id="panel2a-header">
                            <Typography>{val.title}</Typography>
                          </AccordionSummary>
                          <AccordionDetails>
                            <div className="rcs_price_filter">
                              <FormGroup>
                                {val.data?.map((items) => (
                                  <>
                                    <FormControlLabel control={<Checkbox checked={checkboxcheck(val.title, items.value, index)} onChange={(e) => handlecheckChange(e, val.title, items.value, items.name)} />} label={items.name} />
                                  </>
                                ))}
                              </FormGroup>
                            </div>
                          </AccordionDetails>
                        </Accordion>
                      ))}
                    </div>
                  </div>
                </div>
              </Drawer>
            </div>
            <div className={ShopStyle.RightContainer}>
              {/* mj product list */}
              <div className="rcs_list_tablet p-lg-0">
                <div className="rcs_product_list_wrapper">
                  <div className={"rcs_view " + ShopStyle.TopviewProductsBox}>

                    <div className={"rcs_mob_filter1 rcs_ring_setting_filter align-items-center " + ShopStyle.TopviewProductsBoxLeft}>{loader ? <Skeleton variant="text" animation="wave" className="m-auto" width={100} height={25} /> : <span>{productCount} product(s) found </span>} <button className={' rcs_mob_filter mobileFilterBtn ml-3 px-4 py-2'} onClick={() => setLeft(true)}>Filter</button>
                    </div>
                    <div className={ShopStyle.TopviewProductsBoxRight}>
                      <div className={" rcs_ring_setting_filter1 " + ShopStyle.TopviewProductsviewIcon}>


                        <div className="rcs_mob_filter1">
                          <span className={ShopStyle.TopviewProductsBoxtitle}> View</span>
                          <svg className={view == 1 ? "active_grid" : " "}
                            onClick={() => setView(1)} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M0 0H8.57143V8.57143H0V0ZM11.4286 0H20V8.57143H11.4286V0ZM8.57143 11.4286H0V20H8.57143V11.4286ZM11.4286 11.4286H20V20H11.4286V11.4286Z" fill="none" />
                          </svg>
                          {/* <AppsIcon className={view == 1 ? 'active_grid ml-2' : 'ml-2'} onClick={() => setView(1)} /> */}
                          <span style={{ borderRight: '1px solid #ccc' }}></span>
                          {/* <ListIcon className={view == 2 ? 'active_grid ml-2' : 'ml-2'} onClick={() => setView(2)} /> */}
                          <svg className={view == 2 ? "active_grid" : " "}
                            onClick={() => setView(2)} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M0 0H4V4H0V0ZM6.00028 0H20.0003V4H6.00028V0ZM4 8.00014H0V12.0001H4V8.00014ZM0 16.0003H4V20.0003H0V16.0003ZM20.0003 8.00014H6.00028V12.0001H20.0003V8.00014ZM6.00028 16.0003H20.0003V20.0003H6.00028V16.0003Z" fill="none" />
                          </svg>
                          {/* <ul>                                                
                                                <li><AppsIcon className={view == 1 ? "active_grid" : ""} onClick={() => setView(1)} /></li>
                                                <li><span></span></li>
                                                <li><ListIcon className={view == 2 ? "active_grid" : ""} onClick={() => setView(2)} /></li>
                                            </ul> */}
                        </div>

                      </div>
                      <img src={vline} alt="" className={ShopStyle.TopviewProductsVline} />
                      <div className="rcs_sorting">
                        <div className={"rcs_sort_filter mb-3 " + ShopStyle.TopviewProductsshortBy}>
                          <label>
                            {' '}
                            <span className={ShopStyle.TopviewProductsshortByTitle}>Sort By
                              {/* <i>{sortby}</i> */}
                            </span>{' '}
                          </label>
                          <Form.Select
                            onChange={(e) => {
                              setSortby(e.target.value);
                              window.scrollTo(0, 0);
                            }}
                            value={sortby}
                            aria-label="Default select example"
                          >
                            {filterdata?.sort_by?.map((val) => (
                              <option value={val.value}>{val.name}</option>
                            ))}
                          </Form.Select>
                        </div>
                        {/* <Row>
                    <Col xs={2} className="pr-0">
                      {' '}
                      <div className="rcs_sorting_title text-left">
                        <span onClick={() => prev()} className="prev" style={{ opacity: page > 1 ? '1' : '0.2' }}>
                          <ArrowBackIosIcon /> Previous{' '}
                        </span>
                      </div>
                    </Col>
                    <Col xs={8} className="p-0">
                      {' '}
                      
                    </Col>
                    <Col xs={2} className="pl-0">
                      <div className="rcs_sorting_title text-right">
                        {' '}
                        <span onClick={() => next()} className="prev" style={{ opacity: page < pageCount ? '1' : '0.2' }}>
                          Next <ArrowForwardIosIcon />
                        </span>{' '}
                      </div>
                    </Col>
                  </Row> */}
                      </div>
                    </div>
                  </div>

                  {view == 1 ? (
                    <div className="rcs_product_grid">
                      <Row>
                        {listdata?.map((val, index) => (
                          <Col className="mg_nopadd" xs={12} sm={12} md={4}>
                            <div className="rcs_product_item position-relative">
                              {loader ? (
                                <div className="rcs_filter_prod_wrapper">
                                  <CircularProgress className="rcs_filter_prod_loader" />
                                </div>
                              ) : (
                                ''
                              )}
                              {/* <div class="d-flex  hover-buttons justify-content-between">
                                {val.enable_ecommerce == 1 ? (
                                  <span onClick={() => addtocart(val.product_id)}>
                                    {' '}
                                    <img src={cart} />{' '}
                                  </span>
                                ) : (
                                  <span
                                    onClick={() => {
                                      setProductid(val.product_id);
                                      handleShowInquiry(true);
                                    }}
                                  >
                                    {' '}
                                    <img src={inquir} />{' '}
                                  </span>
                                )}
                                <span onClick={() => quickopen(val)}>
                                  {' '}
                                  <Image src={eye} />{' '}
                                </span>
                              </div> */}
                              <NavLink
                                onMouseOver={() => {
                                  setProIndex(index + 1);
                                  console.log(proIndex);
                                }}
                                onMouseLeave={() => setProIndex('')}
                                to={'/productdetail/' + val.slug}
                              >
                                {/* <div class="d-flex  hover-buttons justify-content-between">
                                                                {val.enable_ecommerce == "1" ? <Button onClick={() => handleShowInquiry(true)}> <img src={inquir} />  </Button> : <Button onClick={() => handleShowInquiry(true)}> <img src={inquir} />  </Button>}
                                                                <Button> <img src={eye} />  </Button>
                                                            </div> */}
                                <div class="color-overlay"></div>
                                {val.product_image?.length > 1 ? (
                                  <>
                                    <div>{proIndex == index + 1 ? <img src={val.product_image[1].url} /> : <img src={val.product_image[0].url} />}</div>
                                  </>
                                ) : (
                                  <div className='pro_imgg_outer_boxx'>
                                    <img src={val.product_image[0].url} className='pro_imgg'></img>
                                  </div>

                                )}
                              </NavLink>

                              <div className={ShopStyle.HoverBoxIcons + ' ringSettingHoverBox'}>
                                <div className={ShopStyle.HoverBoxWishlist + ' ringSettingHoverBoxWishlist'}>
                                  {val.is_wishlist == "0" ? <svg onClick={() => addtowishlist(val, index)} className={ShopStyle.HoverBoxWishlist11} width="86" height="86" viewBox="0 0 86 86" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <g filter="url(#filter0_d_1_256)">
                                      <circle cx="43" cy="43" r="23" fill="white" />
                                    </g>
                                    <path d="M53.1494 34.8506C52.5629 34.2639 51.8667 33.7985 51.1003 33.481C50.334 33.1634 49.5126 33 48.6831 33C47.8535 33 47.0321 33.1634 46.2658 33.481C45.4994 33.7985 44.8032 34.2639 44.2167 34.8506L42.9997 36.0677L41.7826 34.8506C40.5981 33.6661 38.9915 33.0006 37.3163 33.0006C35.6411 33.0006 34.0346 33.6661 32.85 34.8506C31.6655 36.0352 31 37.6417 31 39.3169C31 40.9921 31.6655 42.5987 32.85 43.7833L34.0671 45.0003L42.9997 53.9329L51.9323 45.0003L53.1494 43.7833C53.7361 43.1968 54.2015 42.5006 54.519 41.7342C54.8366 40.9679 55 40.1465 55 39.3169C55 38.4874 54.8366 37.666 54.519 36.8997C54.2015 36.1333 53.7361 35.4371 53.1494 34.8506V34.8506Z" stroke="#14344A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                    <defs>
                                      <filter id="filter0_d_1_256" x="0" y="0" width="86" height="86" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                        <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                        <feOffset />
                                        <feGaussianBlur stdDeviation="10" />
                                        <feComposite in2="hardAlpha" operator="out" />
                                        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" />
                                        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1_256" />
                                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1_256" result="shape" />
                                      </filter>
                                    </defs>
                                  </svg> :
                                    <svg onClick={() => addtowishlist(val, index)} className={ShopStyle.HoverBoxWishlist21} width="86" height="86" viewBox="0 0 86 86" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <g filter="url(#filter0_d_1_259)">
                                        <circle cx="43" cy="43" r="23" fill="#607980" />
                                      </g>
                                      <path d="M37.2813 32.0106C35.347 31.9071 33.4069 32.5587 31.9789 33.9959C29.1212 36.878 29.4201 41.7147 32.4778 44.796L33.4545 45.7791L42.3305 54.7204C42.5089 54.8995 42.7506 55 43.0026 55C43.2545 55 43.4962 54.8995 43.6747 54.7204L52.5469 45.7791L53.5236 44.796C56.5812 41.7147 56.8782 36.878 54.0186 33.9978C51.1608 31.1176 46.3649 31.4242 43.3091 34.5037L43.0007 34.8141L42.6922 34.5037C41.1634 32.9611 39.2176 32.1141 37.2813 32.0106Z" fill="white" />
                                      <defs>
                                        <filter id="filter0_d_1_259" x="0" y="0" width="86" height="86" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                          <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                          <feOffset />
                                          <feGaussianBlur stdDeviation="10" />
                                          <feComposite in2="hardAlpha" operator="out" />
                                          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" />
                                          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1_259" />
                                          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1_259" result="shape" />
                                        </filter>
                                      </defs>
                                    </svg>
                                  }
                                </div>
                                <div className={ShopStyle.HoverBoxWishlist + ' ringSettingHoverBoxWishlist'}>
                                  <svg onClick={() => quickopen(val)} className={ShopStyle.HoverBoxWishlist1} width="86" height="86" viewBox="0 0 86 86" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <g filter="url(#filter0_d_1_251)">
                                      <circle cx="43" cy="43" r="23" fill="white" />
                                    </g>
                                    <path d="M54.9088 42.582C52.9428 38.311 48.4998 34 42.9998 34C37.4998 34 33.0568 38.311 31.0908 42.582C31.0309 42.7132 31 42.8558 31 43C31 43.1442 31.0309 43.2868 31.0908 43.418C33.0568 47.689 37.4998 52 42.9998 52C48.4998 52 52.9428 47.689 54.9088 43.418C54.9686 43.2868 54.9995 43.1442 54.9995 43C54.9995 42.8558 54.9686 42.7132 54.9088 42.582V42.582ZM42.9998 50C38.5888 50 34.8538 46.448 33.1098 43C34.8538 39.552 38.5888 36 42.9998 36C47.4108 36 51.1458 39.552 52.8898 43C51.1458 46.448 47.4108 50 42.9998 50Z" fill="#607980" />
                                    <path d="M42.9998 38C42.0109 38 41.0442 38.2932 40.2219 38.8427C39.3997 39.3921 38.7588 40.173 38.3804 41.0866C38.0019 42.0002 37.9029 43.0055 38.0958 43.9755C38.2888 44.9454 38.765 45.8363 39.4642 46.5355C40.1635 47.2348 41.0544 47.711 42.0243 47.9039C42.9942 48.0969 43.9995 47.9978 44.9132 47.6194C45.8268 47.241 46.6077 46.6001 47.1571 45.7779C47.7065 44.9556 47.9998 43.9889 47.9998 43C47.9982 41.6744 47.4709 40.4036 46.5335 39.4662C45.5962 38.5289 44.3254 38.0016 42.9998 38V38ZM42.9998 46C42.4064 46 41.8264 45.8241 41.333 45.4944C40.8397 45.1648 40.4552 44.6962 40.2281 44.1481C40.0011 43.5999 39.9416 42.9967 40.0574 42.4147C40.1732 41.8328 40.4589 41.2982 40.8784 40.8787C41.298 40.4591 41.8325 40.1734 42.4145 40.0576C42.9964 39.9419 43.5996 40.0013 44.1478 40.2284C44.696 40.4554 45.1645 40.8399 45.4942 41.3333C45.8238 41.8266 45.9998 42.4067 45.9998 43C45.9998 43.7956 45.6837 44.5587 45.1211 45.1213C44.5585 45.6839 43.7954 46 42.9998 46Z" fill="#607980" />
                                    <defs>
                                      <filter id="filter0_d_1_251" x="0" y="0" width="86" height="86" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                        <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                        <feOffset />
                                        <feGaussianBlur stdDeviation="10" />
                                        <feComposite in2="hardAlpha" operator="out" />
                                        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" />
                                        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1_251" />
                                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1_251" result="shape" />
                                      </filter>
                                    </defs>
                                  </svg>
                                  <svg onClick={() => quickopen(val)} className={ShopStyle.HoverBoxWishlist2} width="86" height="86" viewBox="0 0 86 86" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <g filter="url(#filter0_d_1_262)">
                                      <circle cx="43" cy="43" r="23" fill="#607980" />
                                    </g>
                                    <path d="M54.91 42.58C52.94 38.31 48.5 34 43 34C37.5 34 33.06 38.31 31.09 42.58C31.0307 42.7121 31 42.8552 31 43C31 43.1448 31.0307 43.2879 31.09 43.42C33.06 47.69 37.5 52 43 52C48.5 52 52.94 47.69 54.91 43.42C54.9693 43.2879 55 43.1448 55 43C55 42.8552 54.9693 42.7121 54.91 42.58V42.58ZM43 48C42.0111 48 41.0444 47.7068 40.2221 47.1573C39.3999 46.6079 38.759 45.827 38.3806 44.9134C38.0022 43.9998 37.9031 42.9945 38.0961 42.0245C38.289 41.0546 38.7652 40.1637 39.4645 39.4645C40.1637 38.7652 41.0546 38.289 42.0245 38.0961C42.9945 37.9031 43.9998 38.0022 44.9134 38.3806C45.827 38.759 46.6079 39.3999 47.1573 40.2221C47.7068 41.0444 48 42.0111 48 43C47.9984 44.3256 47.4711 45.5964 46.5338 46.5338C45.5964 47.4711 44.3256 47.9984 43 48V48Z" fill="white" />
                                    <path d="M43 46C44.6569 46 46 44.6569 46 43C46 41.3431 44.6569 40 43 40C41.3431 40 40 41.3431 40 43C40 44.6569 41.3431 46 43 46Z" fill="white" />
                                    <defs>
                                      <filter id="filter0_d_1_262" x="0" y="0" width="86" height="86" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                        <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                        <feOffset />
                                        <feGaussianBlur stdDeviation="10" />
                                        <feComposite in2="hardAlpha" operator="out" />
                                        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" />
                                        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1_262" />
                                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1_262" result="shape" />
                                      </filter>
                                    </defs>
                                  </svg>
                                </div>
                              </div>
                              <div className="rcs_prod_info">
                                <div className="js_space pt-10">
                                  <h2
                                    onClick={() => {
                                      history.push('/productdetail/' + val.slug);
                                      window.scrollTo(0, 0);
                                    }}
                                    className="rcs_list_title"
                                  >
                                    {val.name}
                                  </h2>
                                  {/* <button class="rcs_wish_btn rcs_wish_btn_desktop">{val.is_wishlist == '0' ? <FavoriteBorderIcon onClick={() => addtowishlist(val, index)} /> : <FavoriteIcon onClick={() => addtowishlist(val, index)} className="animate__animated animate__heartBeat" />}</button> */}
                                </div>
                                <p className="rcs_emailprice">{val.is_price == 1 ? val.currency_icon + val.sale_price : 'Email us for Price'}</p>
                              </div>
                            </div>
                          </Col>
                        ))}
                      </Row>
                    </div>
                  ) : (
                    listdata?.map((val, index) => (
                      <div className="rcs_prodlist_item">
                        <Row>
                          <Col className="mg_nopad" xs={5} sm={5} md={4}>
                            <div className="rcs_product_item rcs_list_img">
                              <button class="rcs_wish_btn">{val.is_wishlist == '0' ? <FavoriteBorderIcon onClick={() => addtowishlist(val, index)} /> : <FavoriteIcon onClick={() => addtowishlist(val, index)} className="animate__animated animate__heartBeat" />}</button>
                              <NavLink
                                onMouseOver={() => {
                                  setProIndex(index + 1);
                                  console.log(proIndex);
                                }}
                                onMouseLeave={() => setProIndex('')}
                                to={'/productdetail/' + val.slug}
                              >
                                <div class="color-overlay"></div>
                                {val.product_image?.length > 1 ? (
                                  <>
                                    <div>{proIndex == index + 1 ? <img src={val.product_image[1].url} /> : <img src={val.product_image[0].url} />}</div>
                                  </>
                                ) : (
                                  <div className='pro_imgg_outer_boxx'>
                                    <img src={val.product_image[0].url} className='pro_imgg'></img>
                                  </div>

                                )}
                              </NavLink>
                            </div>
                          </Col>
                          <Col className="mg_nopad" xs={7} sm={7} md={8}>
                            <div className="rcs_prod_list_info">
                              <div className="d-flex align-items-start pt-10">
                                <h2 className="rcs_list_title">{val.name}</h2>
                              </div>
                              {val.is_price !== '0' ? (
                                <p className="rcs_main_price">
                                  {val.currency_icon}
                                  {val.sale_price}
                                </p>
                              ) : (
                                <p className="rcs_list_email">Email us for Price </p>
                              )}
                              <div className="rcs_dblock">
                                {val.enable_ecommerce == '1' ? (
                                  <Button onClick={() => addtocart(val.product_id)}>
                                    {' '}
                                    <img src={cart} /> ADD TO CART{' '}
                                  </Button>
                                ) : (
                                  <Button
                                    onClick={() => {
                                      setProductid(val.product_id);
                                      handleShowInquiry(true);
                                    }}
                                  >
                                    {' '}
                                    <img src={inquir} /> INQUIRE{' '}
                                  </Button>
                                )}
                                <Button onClick={() => quickopen(val)}>
                                  {' '}
                                  <img src={eye} /> QUICK VIEW{' '}
                                </Button>
                              </div>
                            </div>
                          </Col>
                        </Row>
                      </div>
                    ))
                  )}
                  {/* product list pagination */}
                  {pageCount > 1 ? (
                    <Row className="mt-5 mb-3">
                      <Col xs={1} md={2} className="pr-0">
                        {' '}
                        <div className="rcs_sorting_title">
                          <span onClick={() => prev()} className="prev" style={{ opacity: page > 1 ? '1' : '0.2' }}>
                            <ArrowBackIosIcon /> Previous{' '}
                          </span>
                        </div>
                      </Col>
                      <Col xs={10} md={8} className="p-0">
                        {' '}
                        <div className="rcs_pagination">
                          {' '}
                          <Pagination count={pageCount} page={page} onChange={handlePageChange} />{' '}
                        </div>
                      </Col>
                      <Col xs={1} md={2} className="pl-0">
                        <div className="rcs_sorting_title text-right">
                          {' '}
                          <span onClick={() => next()} className="prev" style={{ opacity: page < pageCount ? '1' : '0.2' }}>
                            Next <ArrowForwardIosIcon />
                          </span>{' '}
                        </div>
                      </Col>
                    </Row>
                  ) : null}
                </div>
                {/* </div> */}
              </div>
            </div>
          </div>
          {/* <Row>
            <Col sm={12} className="p-md-0">
              <div className="rcs_bread_crumb">
                <div role="presentation" onClick={handleClick}>
                  <Col className="rcs_breadcrumb mb-2 p-0">
                    <Breadcrumbs aria-label="breadcrumb">
                      <NavLink underline="hover" color="inherit" to="/">
                        Home
                      </NavLink>
                      <Typography color="text.primary">{paramid?.charAt(0).toUpperCase() + paramid.slice(1).replace('-', ' ')}</Typography>
                    </Breadcrumbs>
                  </Col>
                </div>
                <div className="rcs_category_title">
                  <h1>{paramid?.charAt(0).toUpperCase() + paramid.slice(1).replace('-', ' ')}</h1>
                  {loader ? <Skeleton variant="text" animation="wave" className="mb-4" width={'100%'} height={24} /> : <p>{catediscription}</p>}
                </div>
              </div>
            </Col>
          </Row> */}

          <div className="rcs_bottom_text d-none">
            <Row>
              <Col sm={6}>
                <h5 className="rcs_bottom_title">YOUR DESTINATION FOR ENGAGEMENT RINGS IN CHARLOTTE, NC</h5>
                <p>
                  <small>You’ve found the perfect person, now it’s time to find the perfect ring! With so many choices – from style to cut to design – we understand that the possibilities might be overwhelming. At {client_name.c_name}, we are here to help you navigate through this exciting decision. We are proud to call ourselves advisors and consultants, not salespeople. &nbsp;</small>
                </p>
              </Col>
              <Col sm={6}>
                <h5 className="rcs_bottom_title">THE DIAMOND SPECIALISTS</h5>
                <p>
                  <small>
                    {client_name.c_name} has been family owned and operated for 40 years. We are a direct diamond importer, meaning that we import diamonds, precious gems, bridal and fine jewellery directly to our showroom from Tel Aviv, Israel, Antwerp, Belgium, and many other locations around the world. This allows us to cut out the middleman and pass the savings along to you. All of our diamonds
                    are natural, not lab grown or synthetic, and come with an appraisal for authenticity. &nbsp;
                  </small>
                </p>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <h5 className="rcs_bottom_title">DESIGN HER DREAM ENGAGEMENT RING</h5>
                <p>
                  <small>
                    Having trouble finding ‘THE’ ring? We’re here to help! We can work with you one-on-one to design a custom engagement ring she is guaranteed to love. If you can dream it, we can make it! Schedule an{' '}
                    <NavLink to="/make-an-appointment" className="rcs_list_appointment">
                      appointment
                    </NavLink>{' '}
                    today and make your dream ring a reality.{' '}
                  </small>
                </p>
              </Col>
              <Col sm={6}>
                <h5 className="rcs_bottom_title">WE’VE GOT YOUR BACK&nbsp;</h5>
                <p>
                  <small>
                    With your purchase of a {client_name.c_name} engagement ring, you receive a certificate of insurance appraisal, complimentary sizing and inspection, as well as complimentary cleaning as an ongoing service. With our 100-Day Price Protection guarantee, if within 100 days of your purchase you find a diamond advertised anywhere in the United States with the exact same
                    specifications, we will not just match the price and we will not only match the difference, we will give you 15% of the difference. &nbsp;
                  </small>
                </p>
              </Col>
            </Row>
          </div>
        </Container>
      </div>
      {/*Inquiry Modal*/}
      {inquiry ? <ProductEnquiry productid={productid} handleCloseInquiry={handleCloseInquiry} /> : ''}
      {/*Inquiry Modal*/}
      {/*QuickView Modal*/}
      {quickdata?.name?.length ? (
        <Modal show={quickView} className="rcs_quick_modal" aria-labelledby="contained-modal-title-vcenter" centered onHide={handleCloseQuickView}>
          <Modal.Header>
            <button type="button" onClick={handleCloseQuickView} class="close">
              <span aria-hidden="true">×</span>
              <span class="sr-only">Close</span>
            </button>
          </Modal.Header>
          <Modal.Body>
            <div className="rcs_quick_view">
              <Row className="w-100 m-auto">
                <Col xs={12} sm={6}>
                  <img src={quickdata?.product_image[0]?.url}></img>
                </Col>
                <Col xs={12} sm={6}>
                  <div className="rcs_prod_info">
                    <div className="d-flex align-items-start pt-10">
                      <h2 className="rcs_list_title">{quickdata?.name}</h2>
                      {/* <h2 onClick={() => { history.push("/productdetail/" + quickdata?.slug); window.scrollTo(0, 0) }} className="rcs_list_title">{quickdata?.name}</h2> */}
                      {/* <button class="rcs_wish_btn rcs_wish_btn_desktop">{quickdata?.is_wishlist == "0" ? <FavoriteBorderIcon onClick={() => addtowishlist(quickdata[0])} /> : <FavoriteIcon onClick={() => addtowishlist(quickdata[0])} />}</button> */}
                    </div>
                    <Divider />
                    <p className="rcs_emailprice">
                      <strong>SKU :</strong>
                      {quickdata?.sku}
                    </p>
                    <Divider />
                    <p className="rcs_emailprice">{quickdata?.is_price !== '0' ? quickdata?.currency_icon + quickdata?.sale_price : 'Email us for Price'}</p>
                    <Divider />
                  </div>
                </Col>
              </Row>
            </div>
          </Modal.Body>
          <Modal.Footer>
            {/* <Button variant="secondary" className="rcs_cancel_button mr-2">
                            <MailOutlineIcon className='mr-2' /> Email
                        </Button> */}
            <Button
              variant="secondary"
              className="rcs_cancel_button"
              onClick={() => {
                history.push('/productdetail/' + quickdata?.slug);
                window.scrollTo(0, 0);
              }}
            >
              <ListIcon className="mr-2" /> Details
            </Button>
          </Modal.Footer>
        </Modal>
      ) : (
        ''
      )}
      <>
        { location.pathname === "/jewellery/wedding-rings" && <Container className="">
            <Row>
              <Col>
                <div className="sl_pera_box fAq_eng_Accordian_section text-left">
                  {/* <h2>Shop Diamond Engagement Rings at Swales Diamonds</h2>
                  <LongText
                    getHighlightedDefaultText={secondContentDefault}
                    fullText={secontContentFull}
                  /> */}
                  <Accordion
                    expanded={expanded.includes("panel1")}
                    onChange={handleChangeFaq("panel1")}
                    className="box-shadow lj_faq_accordian "
                  >
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel1bh-content"
                      id="panel1bh-header"
                      className="lj_faq_Question_heading "
                    >
                      <div>
                        <h2 className="mb-0">
                        Shop Wedding Rings and Bands at Swales Diamonds
                        </h2>
                      </div>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Typography>
                        <p className="text-left">
                        Swales Diamond offers a diverse range of <span style={highlightedStyle}>wedding rings for women,</span>
                        each designed with attention to detail and superior craftsmanship. Whether you prefer a simple gold band or a diamond-encrusted ring, our collection caters to every style and taste. We ensure every piece is stunning and durable so your wedding ring will stand the test of time. Explore our collection and allow our experts to assist you in finding the ring that perfectly captures your style and love story.
  </p>
                        <p className="text-left">

                        Your <span style={highlightedStyle}> wedding ring</span> symbolises your eternal bond, and at Swales Diamond, we understand its importance. Our selection of wedding rings offers various designs, ensuring you find the perfect fit to complement your engagement ring or stand alone as a symbol of your commitment. With a focus on quality and customer satisfaction, our team will guide you through the process, making it easy and enjoyable to choose a ring that signifies the start of your forever.
                        </p>
                        <p className="text-left">
                        Our <span style={highlightedStyle}>wedding bands for women</span> are crafted with precision and care, featuring everything from simple, elegant designs to more intricate, diamond-encrusted options. At Swales Diamond, we believe in creating pieces that will remain beautiful and meaningful for years. Our experienced staff is here to help you choose a band that complements your engagement ring and perfectly fits your unique style. Visit us today to discover our stunning collection of wedding bands.
                        </p>
                        <p className="text-left">If you want to purchase a <span style={highlightedStyle}>platinum wedding band,</span> explore the stunning options at Swales Diamond. Platinum offers an elegant, stylish appeal that many brides prefer. Our collection includes a variety of styles to suit every taste. Whether you’re looking for a smooth, shiny band or one decorated with diamonds, each piece is crafted intricately to ensure lasting beauty and durability. Let us help you find the perfect platinum wedding band that adds a touch of grace to your special day.

                        </p>
                      </Typography>
                    </AccordionDetails>
                  </Accordion>
                  <h2 className="my-5 my-md-4 my-sm-4 my-xs-4 my-lg-5 text-center text-uppercase"><strong>Learn More About Wedding Rings (FAQ's)</strong></h2>
                  {faqData.map((faq) => (
          <Accordion
            key={faq.id}
            expanded={expanded.includes(faq.id)}
            onChange={handleChangeFaq(faq.id)}
            className="lj_faq_accordian"
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls={`${faq.id}-content`}
              id={`${faq.id}-header`}
              className="lj_faq_Question_heading"
            >
              <div>
                <h3 className="text-left">{faq.title}</h3>
              </div>
            </AccordionSummary>
            <AccordionDetails>
              <Typography className="lj_faq_Question_ans">{faq.content}</Typography>
            </AccordionDetails>
          </Accordion>
        ))}
                </div>
              </Col>
            </Row>
        </Container>}
      </>
    </>
  );
  
};
export default Productlist;
